/* eslint-disable react-hooks/exhaustive-deps */
import { Box, DialogActions, DialogContent, Button, TextField, Autocomplete } from '@mui/material'
import { CustomTextField } from 'Components/CustomTextField'
import React, { useEffect } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { CATEGORIE } from 'utils/constants'
import { STATUT } from 'utils/constants'
import { TIMING_BUCKET } from 'utils/constants'

export const GeneralInformationForm = ({
  formErrors,
  setStep,
  setUtilisationType,
  setFinalPayload,
  handleSubmitData,
  handleClose,
  activeDocument,
}) => {
  const {
    handleSubmit,
    formState: { errors },
    reset,
    control,
  } = useForm({
    defaultValues: {
      Nom: '',
      Description: '',
      Categorie: '',
      Prix: '',
      Devise: '',
      Temps: '',
      DateObjectif: '',
      Duree: '',
      Statut: '',
      Datedecreation: '',
    },
  })

  useEffect(() => {
    if (Object.keys(activeDocument).length > 0) {
      reset({ ...activeDocument })
    }
  }, [activeDocument])

  const onSubmit = (data) => {
    const payload = { ...data }
    handleSubmitData(payload)

    // setUtilisationType(data.utilisation)
    // setFinalPayload({ ...payload })
    // setStep(1)
  }
  return (
    <Box component="form" onSubmit={handleSubmit(onSubmit)}>
      <DialogContent>
        <CustomTextField required label="Nom" fullWidth placeholder="Donner un nom à votre rêve" />
        <CustomTextField
          required
          label="Déscription"
          fullWidth
          placeholder="Indiquer une descriptio"
        />
        <Controller
          name={'Catégorie'}
          control={control}
          rules={{
            required: true,
          }}
          render={({ field }) => (
            <Autocomplete
              disablePortal
              disabled={activeDocument.utilisation ? true : false}
              sx={{ marginTop: '7px' }}
              options={CATEGORIE}
              getOptionLabel={(option) =>
                option?.label ?? CATEGORIE.find(({ id }) => id === option)?.label ?? ''
              }
              isOptionEqualToValue={(option, value) => option.label === value.label}
              {...field}
              renderInput={(params) => (
                <TextField required {...params} size="small" label="Catégorie" />
              )}
              onChange={(_event, data) => field.onChange(data?.id || '')}
            />
          )}
        />
        <CustomTextField
          label="Prix"
          type="number"
          fullWidth
          placeholder="Quel prix coûte se rêve"
        />
        <CustomTextField label="Devise" fullWidth placeholder="Sélectionner devise" />
        <Controller
          name={'Horizon'}
          control={control}
          rules={{
            required: true,
          }}
          render={({ field }) => (
            <Autocomplete
              disablePortal
              disabled={activeDocument.Temps ? true : false}
              sx={{ marginTop: '7px' }}
              options={TIMING_BUCKET}
              getOptionLabel={(option) =>
                option?.label ?? TIMING_BUCKET.find(({ id }) => id === option)?.label ?? ''
              }
              isOptionEqualToValue={(option, value) => option.label === value.label}
              {...field}
              renderInput={(params) => (
                <TextField required {...params} size="small" label="Hoizon de temps" />
              )}
              onChange={(_event, data) => field.onChange(data?.id || '')}
            />
          )}
        />
        <CustomTextField label="DateObjectif" fullWidth placeholder="DateObjectif" />
        <CustomTextField label="Duree" fullWidth placeholder="Selectionner la durée" />
        <Controller
          name={'statut'}
          control={control}
          rules={{
            required: true,
          }}
          render={({ field }) => (
            <Autocomplete
              disablePortal
              disabled={activeDocument.Statut ? true : false}
              sx={{ marginTop: '7px' }}
              options={STATUT}
              getOptionLabel={(option) =>
                option?.label ?? STATUT.find(({ id }) => id === option)?.label ?? ''
              }
              isOptionEqualToValue={(option, value) => option.label === value.label}
              {...field}
              renderInput={(params) => (
                <TextField required {...params} size="small" label="Statut" />
              )}
              onChange={(_event, data) => field.onChange(data?.id || '')}
            />
          )}
        />
      </DialogContent>
      <DialogActions>
        <Button type="submit">Valider</Button>
        <Button onClick={handleClose}>Annuler</Button>
      </DialogActions>
    </Box>
  )
}
